import { useTranslate } from "react-admin";

import Stack from "@mui/material/Stack";

export default function SearchFirstDataGridOverlay() {
  const translate = useTranslate();
  const t = (key: string) => translate(`message.${key}`);
  return (
    <Stack height="100%" alignItems="center" justifyContent="center">
      {t("reminder")}
    </Stack>
  );
}
